const STORAGE_KEY = "fx_cart_backup";

function lineId(item) {
  const raw = item?.variantId;
  if (!raw) return "";
  if (typeof raw === "object") return String(raw._id || raw.id || "");
  return String(raw);
}

export function cartLinesFromCart(cart) {
  return (cart?.items || [])
    .map((item) => ({
      variantId: lineId(item),
      quantity: Math.max(1, Number(item.quantity) || 1),
    }))
    .filter((line) => line.variantId);
}

export function loadCartBackup() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((line) => ({
        variantId: String(line?.variantId || ""),
        quantity: Math.max(1, Number(line?.quantity) || 1),
      }))
      .filter((line) => line.variantId);
  } catch {
    return [];
  }
}

export function saveCartBackup(cart) {
  try {
    const lines = cartLinesFromCart(cart);
    if (!lines.length) {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lines));
  } catch {
    /* quota / private mode */
  }
}

export function clearCartBackup() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
